import React, { useState, useRef, useEffect } from "react";
import $ from "jquery";
import {
  Button,
  confirmDelete,
  ErrorMsg,
  InfoIcon,
  sessionUser,
  ValidateForm,
} from "../../Util/common";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { CorebaseURL, corefetch, corepost } from "../../Util/axios_core_helper";
import { KendoLoader } from "../../Kendo/kendo_loader";

export const Highlights = () => {
  const [highlightsList, sethighlightsList] = useState([]);
  const [editVisible, setEditVisible] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [Highlight, setHighlight] = useState({
    highlightsID: 0,
    title: "",
    count: "",
    sortOrder: "",
  });
  const [refreshflag, setrefreshflag] = useState(0);
  const [error, setError] = useState({});
  // const [HighlightsList, setHighlightsList] = useState([]);

  const modalRef = useRef(null); // Reference for modal
  const [isDuplicate, SetisDuplicate] = useState(false);
  // Clear form inputs
  const clearForm = () => {
    setLoading(false);
    $("#hide").click();
    setHighlight({
      highlightsID: 0,
      title: "",
      count: "",
      sortOrder: "",
    });
    setError({});
    setEditVisible(false);
    SetisDuplicate(false);
    const form = document.getElementById("HighlightsForm");
    if (form) {
      form.reset(); // Reset form
    }
    $("#btn-reset").click();
  };

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    var err = ValidateForm(e);

    if (err) {
      setError(err);
    } else if (!isDuplicate) {
      setLoading(true);
      let data = {
        createdBy: 1,
        highlightsID: 0,
        title: $("#Title").val(),
        count: $("#Count").val(),
      };
      if (editVisible) {
        data = {
          createdBy: 1,
          highlightsID: Highlight.highlightsID,
          title: $("#Title").val(),
          count: $("#Count").val(),
        };
        await corepost(
          "HighlightsAwards/InsertUpdateHighlights",
          data,
          true,
          false,
          false,
          true
        );
        fetchData();
      } else {
        await corepost("HighlightsAwards/InsertUpdateHighlights", data);
        fetchData();
      }
      clearForm();
      $("#ballroom-fun-cancel").click();
      setrefreshflag(refreshflag + 1);
    }
  };

  const handleEditClick = async (e) => {
    setHighlight({
      highlightsID: e.highlightsID,
      title: e.title,
      count: e.count,
      sortOrder: e.sortOrder,
    });
    setEditVisible(true);
    const modal = new bootstrap.Modal(
      document.getElementById("HighlistsModal")
    );
    modal.show();
  };

  const handleDeleteClick = async (e) => {
    const onDelete = () => {
      corefetch(
        `HighlightsAwards/DeleteHighlights?id=${e.highlightsID}`,
        true,
        false,
        true
      ).then(() => {
        fetchData();
        setrefreshflag(refreshflag + 1);
      });
    };
    confirmDelete(onDelete);
  };

  const onRowReorderChange = async (List) => {
    let highlightsID = $(List.newRow).find("td").eq(0).text();
    let oldSortId = $(List.newRow).find("td").eq(1).text();
    let newSortId = $(List.oldRow).find("td").eq(1).text();
    await corefetch(
      `HighlightsAwards/SortHighlights?TypeId=${highlightsID}&newSortId=${newSortId}&oldSortId=${oldSortId}`
    );

    setrefreshflag(refreshflag + 1);
  };

  const fetchData = async () => {
    try {
      const list = await corefetch("HighlightsAwards/GetHighlights");
      sethighlightsList(list);
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="card bg-white">
        <div className="card-body">
          <div className="col-auto ms-auto">
            <div className="row">
              <div className="col-sm-6"></div>
              <div className="col-auto float-end ms-auto">
                <div className="d-flex justify-content-end mb-2">
                  <Button
                    name={"Add"}
                    dataBsToggle={"modal"}
                    dataBsTarget={"#HighlistsModal"}
                    dataBsDismiss={"modal"}
                  />
                </div>
              </div>
            </div>

            <div>
              <i>
                <span style={{ backgroundColor: "yellow", fontWeight: "bold" }}>
                  Note:
                </span>{" "}
                This module supports drag-and-drop functionality. You can easily
                rearrange or move data as needed.
              </i>
              <KendoGrid
                name={"Highlights"}
                url={CorebaseURL + "HighlightsAwards/GetHighlights"}
                columns={[
                  { field: "highlightsID", hidden: true },
                  { field: "sortOrder", hidden: true },
                  { field: "title", title: "Title" },
                  { field: "count", title: "Count" },
                ]}
                showOptions={true}
                showEdit={true}
                showDelete={true}
                onEditClick={handleEditClick}
                onDeleteClick={handleDeleteClick}
                enableRowReorderable={true}
                disableExportExcel={true}
                height={"60vh"}
                onRowReorder={onRowReorderChange}
                refreshWhen={refreshflag}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Adding or Editing */}
      <div
        className="modal custom-modal fade"
        id="HighlistsModal"
        data-bs-backdrop="static"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-dialog-centered highlights">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{editVisible ? "Edit" : "Add"}</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="HighlightsForm" onSubmit={onSubmit}>
                <input
                  type="hidden"
                  name="TypeId"
                  value={Highlight.highlightsID}
                />
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="form-label">
                        Title <span className="text-danger">*</span>
                        <InfoIcon content="Please provide a Title with a maximum length of 30 characters." />
                      </label>
                      <input
                        type="text"
                        maxLength={30}
                        className="form-control field"
                        name="Title"
                        id="Title"
                        defaultValue={Highlight.title}
                        placeholder="Title"
                        data-required="true"
                        onChange={(e) => {
                          setHighlight((prev) => ({
                            ...prev,
                            title: e.target.value,
                          }));
                          onValidation("Title", e.target.value);
                          let dup;
                          if (Highlight.highlightsID > 0) {
                            const matchingItem = highlightsList.find(
                              (item) =>
                                item.title.trim().toLowerCase() ==
                                  e.target.value.trim().toLowerCase() &&
                                item.highlightsID != Highlight.highlightsID
                            );

                            dup = matchingItem;
                            SetisDuplicate(dup);
                          } else {
                            const matchingItem = highlightsList.find(
                              (item) =>
                                item.title.trim().toLowerCase() ==
                                e.target.value.trim().toLowerCase()
                            );
                            dup = matchingItem;
                            SetisDuplicate(dup);
                          }
                        }}
                      />

                      {error.Title && <ErrorMsg text="Title is required" />}
                      {isDuplicate && (
                        <ErrorMsg text="Title is already exist" />
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="form-label">
                        Count <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        maxLength={10}
                        className="form-control field"
                        name="Count"
                        id="Count"
                        defaultValue={Highlight.count}
                        placeholder="Count"
                        data-required="true"
                        min="0"
                        onChange={(e) => {
                          const regex = /^\d{0,10}$/; // Regex to allow only up to 10 digits
                          const value = e.target.value;

                          if (regex.test(value)) {
                            onValidation("Count", value); // Call validation function if valid
                          } else {
                            e.target.value = value.slice(0, 10); // Truncate to 10 digits
                          }
                        }}
                      />
                      {error.Count && <ErrorMsg text="Count is required" />}
                    </div>
                  </div>
                </div>
                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      id="ballroom-fun-cancel"
                      dataBsDismiss={"modal"}
                      onClick={clearForm}
                    />
                    {/* <Button name={"Save"} /> */}
                    <Button name={editVisible ? "Update" : "Save"} />
                  </div>
                )}
                <button
                  type="button"
                  id="hide"
                  style={{ display: "none" }}
                  data-bs-dismiss={"modal"}
                  onClick={() => {
                    clearForm();
                  }}
                ></button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Hidden reset button */}
      <button type="reset" id="btn-reset" style={{ display: "none" }}></button>
    </>
  );
};
